import { useQuery } from "shared/hooks/useApi";
import { INSURANCE_PLANS } from "utils/api/graphql/queries/insurance-plans";

export const insurancePlansVariables = (
  selectedIds,
  eligibilityRules,
  standalone,
) => {
  const ids = (selectedIds || []).filter(Boolean);
  const rules = (eligibilityRules || []).filter(Boolean);
  if (ids.length) {
    return rules.length ? { isIn: { id: ids }, rules } : { isIn: { id: ids } };
  }
  const where =
    standalone === true || standalone === false
      ? { isStandalone: standalone }
      : null;
  if (!rules.length) return where ? { where } : { where: {} };
  return where ? { where, rules } : { rules };
};

export const useInsurancePlans = (
  enabled,
  selectedIds,
  eligibilityRules,
  standalone,
) => {
  const { data } = useQuery(INSURANCE_PLANS, {
    variables: insurancePlansVariables(
      selectedIds,
      eligibilityRules,
      standalone,
    ),
    skip: !enabled,
  });
  return { insurancePlans: data?.insurancePlans?.data || [] };
};
